import { directions, orbitLimits } from '@inter-ikea-storageone/range';

const getCameraConfig = (widgetId: string) => {
  let direction = directions.FRONT_ANGLED;
  let limits = orbitLimits.FRONT_ANGLED;
  switch (widgetId) {
    case 'add-frame':
      direction = directions.FRONT;
      limits = orbitLimits.FRONT;
      break;
    case 'change-frame-color':
      direction = directions.FRONT_ANGLED;
      limits = orbitLimits.FRONT_ANGLED;
      break;
    case 'change-solution-size-depth':
      direction = directions.FRONT_ANGLED_STEEP;
      limits = orbitLimits.FRONT_ANGLED_STEEP;
      break;
    case 'change-solution-size-height':
      direction = directions.FRONT_ANGLED;
      limits = orbitLimits.FRONT_ANGLED;
      break;
    case 'change-interior-color':
      direction = directions.FRONT;
      limits = orbitLimits.FRONT;
      break;
    case 'interior-suggestions':
      direction = directions.FRONT;
      limits = orbitLimits.FRONT;
      break;
    case 'interiors':
      direction = directions.FRONT;
      limits = orbitLimits.FRONT;
      break;
    default:
      break;
  }
  return { direction, orbitLimits: limits };
};

export default getCameraConfig;
